/**
 * @jsxRuntime classic
 * @jsx jsx
 */

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { css, cx, jsx } from '@compiled/react';

import { cssMap } from '@atlaskit/css';
import { Inline } from '@atlaskit/primitives/compiled/inline';
import { token } from '@atlaskit/tokens';

/**
 * The text colors `@atlaskit/logo` uses. The light/dark swap is in CSS, keyed on the
 * `data-color-mode` the pre-paint script has already set on `<html>`, so the prerendered markup is
 * identical for every reader. See `AtlassianDesignLogo`.
 */
const textColorStyles = css({
	'--ads-logo-text-color': '#101214',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- swaps the color by color mode without re-rendering
	'html[data-color-mode="dark"] &': {
		'--ads-logo-text-color': '#E2E3E4',
	},
});
const logoStyles = cssMap({
	baseStyles: { color: token('color.text') },
	smallIconWrapper: {
		display: 'inline-block',
		flexShrink: 0,
	},
});

/**
 * A small (icon-only) Atlassian Design logo.
 *
 * Uses the same light/dark theming behavior as `AtlassianDesignLogo`.
 */
export const AtlassianDesignLogoSmall: ({ size }: { size?: number }) => React.ReactNode = ({
	size = 24,
}: {
	size?: number;
}): React.ReactNode => {
	return (
		<Inline alignBlock="center" xcss={cx(logoStyles.baseStyles)}>
			<span
				css={[logoStyles.smallIconWrapper, textColorStyles]}
				style={{
					width: size,
					height: size,
				}}
			>
				<svg
					width="30"
					height="20"
					viewBox="0 0 30 20"
					aria-label="Atlassian Design"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M5.62997 16.0278C5.5575 16.1712 5.41402 16.2437 5.26908 16.2437H0.40646C0.118036 16.2437 -0.0979195 15.9191 0.0455677 15.6308L3.53999 8.64425C3.68347 8.35592 4.00813 8.35592 4.22409 8.5718C6.06188 10.5524 6.67351 13.8661 5.62852 16.0263L5.62997 16.0278ZM6.78367 2.23581C4.83862 5.33353 4.94587 8.75436 6.24305 11.3464C7.54023 13.9399 8.51276 15.8844 8.58523 16.0278C8.65769 16.1712 8.80118 16.2437 8.94612 16.2437H13.8087C14.1334 16.2437 14.3131 15.9191 14.1696 15.6308C14.1696 15.6308 7.6127 2.52269 7.46921 2.19814C7.32573 1.94603 6.96484 1.90981 6.78512 2.23436L6.78367 2.23581Z"
						fill="var(--ads-logo-text-color)"
					/>
				</svg>
			</span>
		</Inline>
	);
};
